<span [innerHTML]="value() | currencyFormat | async"></span>
